


// import React from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation, Autoplay } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";

// const fleets = [
//   {
//     id: 1,
//     img: "/images/Ourfleet/1.png",
//     title: "Swift Dzire",
//     type: "Sedan | Budget & Corporate Travel",
//     pricing: "₹1800",
//     features: ["4 Passengers", "4 Doors", "2 Bags", "AC & Music System"],
//     bookLink: "/sedan",
//   },
//   {
//   id: 2,
//   img: "/images/Ourfleet/6.jpg",
//   title: "Tata Tigor EV",
//   type: "Sedan | City & Airport Transfer",
//   pricing: "₹2500",
//   features: [
//     "5 Passengers",
//     "4 Doors",
//     "2 Bags",
//     "Automatic Climate Control"
//   ],
//   bookLink: "/E-Vehical",
// },
//   {
//     id: 4,
//     img: "/images/Ourfleet/4.jpg",
//     title: "Toyota Innova Crysta",
//     type: "Luxury SUV | Business & Tourist Travel",
//     pricing: "₹3500",
//     features: [
//       "6/7 Passengers",
//       "Dual Zone AC",
//       "Pushback Seats",
//       "Airbags",
//     ],
//     bookLink: "/muv",
//   },
// {
//   id: 3,
//   img: "/images/Ourfleet/5.jpg",
//   title: "Tata Nexon EV",
//   type: "Compact SUV | Premium Family Travel",
//   pricing: "₹3200",
//   features: [
//     "5 Passengers",
//     "Spacious Seating",
//     "Large Boot Space",
//     "Touchscreen Infotainment"
//   ],
//   bookLink: "/E-Vehical",
// },


// ];

// const PerfectFleet = () => {
//   const whatsapp = (fleet) =>
//     `https://wa.me/919730707888?text=Hi%20Aaryan%20Travels!%20I%20want%20to%20book%20${encodeURIComponent(
//       fleet.title
//     )}%20(${encodeURIComponent(
//       fleet.type
//     )}).%20Please%20share%20availability%20and%20fare.`;

//   return (
//     <section className="perfect-fleet aaryan-bg">
//       <div className="container">
//         <header className="fleet-head">
//             <div className="section-title">
//                 <h3 className="wow fadeInUp">Our Fleets</h3>
//                 <h2 className="text-anime-style-3" data-cursor="-opaque">
//                   Premium Cars for Pan-India Travel
//                 </h2>
//                 <p className="wow fadeInUp" data-wow-delay="0.25s">
//                   Aaryan Travels • Travel with Luxury and Comfort
//                 </p>
//               </div>

//           {/* <div className="head-left">
//             <div>


//               <h3>Our Fleets</h3>
//               <h2>Premium Cars for Pan-India Travel</h2>
//               <p className="sub">
//                 Aaryan Travels • Travel with Luxury and Comfort
//               </p>
//             </div>
//           </div> */}

//           <div className="nav-wrap">
//             <button
//               className="nav-btn car-button-prev"
//               aria-label="Previous"
//             >
//               ‹
//             </button>
//             <button
//               className="nav-btn primary car-button-next"
//               aria-label="Next"
//             >
//               ›
//             </button>
//           </div>
//         </header>

//         <Swiper
//           modules={[Navigation, Autoplay]}
//           autoplay={{ delay: 3200, disableOnInteraction: false }}
//           navigation={{
//             nextEl: ".car-button-next",
//             prevEl: ".car-button-prev",
//           }}
//           loop
//           spaceBetween={24}
//           slidesPerView={1}
//           breakpoints={{
//             640: { slidesPerView: 1.2 },
//             768: { slidesPerView: 2 },
//             1024: { slidesPerView: 3 },
//             1280: { slidesPerView: 3.5 },
//           }}
//         >
//           {fleets.map((fleet) => (
//             <SwiperSlide key={fleet.id}>
//               <article className="fleet-card">
//                 <div className="image-box">
//                   <img
//                     src={fleet.img}
//                     alt={fleet.title}
//                     loading="lazy"
//                   />
//                 </div>

//                 <h4 className="title py-4">{fleet.title}</h4>

//                 <ul className="feature-list">
//                   {fleet.features.map((feature, index) => (
//                     <li key={index}>
//                       <span className="dot" />
//                       {feature}
//                     </li>
//                   ))}
//                 </ul>

//                 <footer className="card-foot">
//                   <div className="cta">
//                     <a
//                       className="ghost"
//                       href={whatsapp(fleet)}
//                       target="_blank"
//                       rel="noreferrer"
//                     >
//                       WhatsApp
//                     </a>

//                     <a
//                       className="filled"
//                       href={fleet.bookLink}
//                     >
//                       Book Now
//                     </a>
//                   </div>
//                 </footer>
//               </article>
//             </SwiperSlide>
//           ))}
//         </Swiper>
//       </div>
//     </section>
//   );
// };

// export default PerfectFleet;








import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const fleets = [
  {
    id: 1,
    img: "/images/Ourfleet/1.png",
    title: "Swift Dzire",
    type: "Sedan | Budget & Corporate Travel",
    pricing: "₹1800",
    features: ["4 Passengers", "4 Doors", "2 Bags", "AC & Music System"],
    bookLink: "/sedan",
  },
  {
    id: 2,
    img: "/images/Ourfleet/6.jpg",
    title: "Tata Tigor EV",
    type: "Sedan | City & Airport Transfer",
    pricing: "₹2500",
    features: [
      "5 Passengers",
      "4 Doors",
      "2 Bags",
      "Automatic Climate Control",
    ],
    bookLink: "/E-Vehical",
  },
  {
    id: 3,
    img: "/images/Ourfleet/4.jpg",
    title: "Toyota Innova Crysta",
    type: "Luxury SUV | Business & Tourist Travel",
    pricing: "₹3500",
    features: [
      "6/7 Passengers",
      "Dual Zone AC",
      "Pushback Seats",
      "Airbags",
    ],
    bookLink: "/muv",
  },
  {
    id: 4,
    img: "/images/Ourfleet/5.jpg",
    title: "Tata Nexon EV",
    type: "Compact SUV | Premium Family Travel",
    pricing: "₹3200",
    features: [
      "5 Passengers",
      "Spacious Seating",
      "Large Boot Space",
      "Touchscreen Infotainment",
    ],
    bookLink: "/E-Vehical",
  },
];

const PerfectFleet = () => {
  const whatsapp = (fleet) =>
    `https://wa.me/919730707888?text=Hi%20Aaryan%20Travels!%20I%20want%20to%20book%20${encodeURIComponent(
      fleet.title
    )}%20(${encodeURIComponent(
      fleet.type
    )}).%20Please%20share%20availability%20and%20fare.`;

  return (
    <section className="perfect-fleet aaryan-bg">
      <div className="container">
        <header className="fleet-head">
          <div className="section-title">
            <h3>Our Fleets</h3>
            <h2>Premium Cars for Pan-India Travel</h2>
            <p>Aaryan Travels • Travel with Luxury and Comfort</p>
          </div>

          <div className="nav-wrap">
            <button className="nav-btn car-button-prev" aria-label="Previous">
              ‹
            </button>
            <button
              className="nav-btn primary car-button-next"
              aria-label="Next"
            >
              ›
            </button>
          </div>
        </header>

        <Swiper
          modules={[Navigation, Autoplay]}
          autoplay={{ delay: 3200, disableOnInteraction: false }}
          navigation={{
            nextEl: ".car-button-next",
            prevEl: ".car-button-prev",
          }}
          loop
          spaceBetween={24}
          slidesPerView={1}
          breakpoints={{
            0: {
              slidesPerView: 1,
              spaceBetween: 16,
            },
            640: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
            1280: {
              slidesPerView: 3.5,
            },
          }}
        >
          {fleets.map((fleet) => (
            <SwiperSlide key={fleet.id}>
              <article className="fleet-card">
                <div className="image-box">
                  <img
                    src={fleet.img}
                    alt={fleet.title}
                    loading="lazy"
                  />
                </div>

                <h4 className="title pt-5 pb-2">{fleet.title}</h4>

                <ul className="feature-list">
                  {fleet.features.map((feature, index) => (
                    <li key={index}>
                      <span className="dot" />
                      {feature}
                    </li>
                  ))}
                </ul>

                <footer className="card-foot">
                  <div className="cta">
                    <a
                      className="ghost"
                      href={whatsapp(fleet)}
                      target="_blank"
                      rel="noreferrer"
                    >
                      WhatsApp
                    </a>

                    <a className="filled" href={fleet.bookLink}>
                      Book Now
                    </a>
                  </div>
                </footer>
              </article>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default PerfectFleet;
